import React from "react";
import { ArrowUpRight } from "lucide-react";
import JournalArtwork from "./JournalArtwork";

/**
 * JournalCard — premium editorial grid card. Featured variant is
 * wider and uses a larger artwork. Both share the same hover
 * (translateY + gold border bloom) so the grid reads as one library.
 */
const JournalCard = ({ post, featured = false }) => (
  <a
    href={`/journal/${post.slug}`}
    data-testid={`journal-card-${post.slug}`}
    className={`journal-card group block bg-white/5 border-t border-gold/20 p-8 rounded-lg ${featured ? "is-featured" : ""}`}
  >
    <div className="journal-card-art">
      <JournalArtwork
        motif={post.featuredImage.motif}
        alt={post.featuredImage.alt}
        aspect={featured ? "21/9" : "16/9"}
      />
      <div className="journal-card-tags">
        {post.themeTags.map((t) => (
          <span key={t} className="journal-tag">
            {t}
          </span>
        ))}
      </div>
    </div>
    <div className="journal-card-body">
      <div className="flex items-center gap-3 text-[10px] tracking-[0.3em] uppercase text-gold/75 mb-3">
        <span>{post.readingTime}</span>
        <span className="text-themed-muted/40">·</span>
        <span className="text-themed-muted/70">{post.publishedAt}</span>
      </div>
      <h3
        className={`font-serif text-themed leading-tight ${featured ? "text-3xl md:text-4xl lg:text-5xl" : "text-xl md:text-2xl"}`}
      >
        {post.title}
      </h3>
      <p className="text-white/85 text-sm md:text-base mt-4 leading-relaxed">
        {post.excerpt}
      </p>
      <span className="mt-6 inline-flex items-center gap-1.5 text-[11px] tracking-[0.3em] uppercase text-gold/80 group-hover:text-gold transition-colors">
        Read the reflection <ArrowUpRight size={12} />
      </span>
    </div>
  </a>
);

export default JournalCard;
